// blocker-B1 fix (2026-10-09): BE /home/shopping/sort-order PUT
// (src/modules/home/shopping.routes.js isValidSortOrder) requires BOTH
// listOrder (array of strings) and itemOrder (object) on every PUT. Partial
// payloads always 400'd, so drag-and-drop reordering never persisted.
// This helper builds the complete payload and fails fast (throw, not console)
// if either key would be missing. The check mirrors the BE validator, costs
// nothing, and only throws on programmer error (never with valid state).
export function buildSortOrderPayload(
  listOrder: string[],
  itemOrder: Record<string, string[]>
): { listOrder: string[]; itemOrder: Record<string, string[]> } {
  const listOk = Array.isArray(listOrder) && listOrder.every(k => typeof k === 'string' && k.length > 0);
  const itemOk =
    !!itemOrder &&
    typeof itemOrder === 'object' &&
    !Array.isArray(itemOrder) &&
    Object.values(itemOrder).every(ids => Array.isArray(ids) && ids.every(id => typeof id === 'string' && id.length > 0));
  if (!listOk || !itemOk) {
    throw new Error(
      `sort-order PUT payload contract violated: listOrder must be a non-empty-string array (got ${JSON.stringify(listOrder)?.slice(0, 120)}) and itemOrder must be an object of string arrays (got ${JSON.stringify(itemOrder)?.slice(0, 120)})`
    );
  }
  return { listOrder, itemOrder };
}
